export enum QueryKey {
  CsvIngestions = 'csv_ingestions',
  Transactions = 'transactions',
  PaginatedTransactions = 'paginated_transactions',
  TransactionsReader = 'transactions_streaming_reader',
  Wallets = 'wallets',
  Sources = 'sources',
  SourceStatuses = 'source_statuses',
  DefaultSources = 'default_sources',
  ZeusSources = 'zeus_sources',
  WalletBalances = 'wallet_balances',
  GainLossEvents = 'gain_loss_events',
  TransactionValueOverrides = 'transaction_value_overrides',
  ErpStatus = 'erp_status',
  ErpAccounts = 'erp_accounts',
  ErpClasses = 'erp_classes',
  ErpCustomers = 'erp_customers',
  ErpLocations = 'erp_locations',
  ErpVendors = 'erp_vendors',
  CustomErpMappingEnabled = 'custom_erp_mapping_enabled',
  AccountingMappings = 'accounting_mappings',
  AccountingMappingsCsv = 'accounting_mappings_csv',
  AccountingDocNumberPrefix = 'accounting_docnumberprefix',
  AccountingSyncStatuses = 'accounting_sync_statuses',
  AccountingSyncStatusesForFilters = 'accounting_sync_statuses_for_filters',
  Coinbase = 'coinbase_wallet_data',
  CoinbaseIaas = 'coinbase_iaas_data',
  CoinbaseIaasStatus = 'coinbase_iaas_status',
  CoinbaseExchangeIaas = 'coinbase_exchange_iaas_data',
  CoinbaseExchangeIaasStatus = 'coinbase_exchange_iaas_status',
  CoinbasePrimeIaas = 'coinbase_prime_iaas_data',
  CoinbasePrimeIaasStatus = 'coinbase_prime_iaas_status',
  AnchorageIaasStatus = 'anchorage_iaas_status',
  AnchorageIaasDate = 'anchorage_iaas_date',
  FireblocksStatus = 'fireblocks_status',
  FireblocksDate = 'fireblocks_date',
  Gemini = 'gemini_wallet_data',
  GeminiIaas = 'gemini_iaas_data',
  GeminiIaasStatus = 'gemini_iaas_status',
  KrakenStatus = 'kraken_status',
  KrakenDate = 'kraken_date',
  KuCoinStatus = 'kucoin_status',
  KuCoinDate = 'kucoin_date',
  OptimismStatus = 'optimism_status',
  OptimismDate = 'optimism_date',
  ArbitrumStatus = 'arbitrum_status',
  ArbitrumDate = 'arbitrum_date',
  ArbitrumNovaStatus = 'arbitrum_nova_status',
  ArbitrumNovaDate = 'arbitrum_nova_date',
  BaseStatus = 'base_status',
  BaseDate = 'base_date',
  CantoStatus = 'canto_status',
  CantoDate = 'canto_date',
  CardanoStatus = 'cardano_status',
  CardanoDate = 'cardano_date',
  AvalancheStatus = 'avalanche_status',
  AvalancheDate = 'avalanche_date',
  BitcoinStatus = 'bicoin_status',
  BitcoinDate = 'bitcoin_date',
  BitfinexStatus = 'bitfinex_status',
  BitfinexDate = 'bitfinex_date',
  ProtonStatus = 'proton_status',
  ProtonDate = 'proton_date',
  BitgoStatus = 'bitgo_status',
  BitgoDate = 'bitgo_date',
  LitecoinStatus = 'ltc_status',
  LitecoinDate = 'ltc_date',
  NearStatus = 'near_status',
  NearDate = 'near_date',
  RippleCustodyStatus = 'ripple_custody_status',
  RippleCustodyDate = 'ripple_custody_date',
  RootstockStatus = 'rootstock_status',
  RootstockDate = 'rootstock_date',
  BinanceSmartChainStatus = 'bsc_status',
  BinanceSmartChainDate = 'bsc_date',
  BitcoinCashStatus = 'bch_status',
  BitcoinCashDate = 'bch_date',
  DashStatus = 'dash_status',
  DashDate = 'dash_date',
  DogeStatus = 'doge_status',
  DogeDate = 'doge_date',
  CircleStatus = 'circle_status',
  CircleDate = 'circle_date',
  SolanaStatus = 'solana_status',
  SolanaDate = 'solana_date',
  SolanaNewStatus = 'solana_new_status',
  SolanaNewDate = 'solana_new_date',
  PolygonStatus = 'polygon_status',
  PolygonDate = 'polygon_date',
  EthereumStatus = 'ethereum_status',
  EthereumDate = 'ethereum_date',
  VoltageStatus = 'voltage_status',
  VoltageDate = 'voltage_date',
  SynotaStatus = 'synota_status',
  SynotaDate = 'synota_date',
  TronStatus = 'tron_status',
  TronDate = 'tron_date',
  FoundryStatus = 'foundry_status',
  FoundryDate = 'foundry_date',
  ExchangeRates = 'exchange_rates',
  DashboardAssetByDate = 'dashboard_asset_by_date',
  DashboardCurrentAssets = 'dashboard_current_assets',
  DashboardSummary = 'dashboard_summary_key',
  DashboardMainTransactionsCount = 'dashboard_main_transactions_count_key',
  BalanceReport = 'balance_report',
  GainlossReport = 'gainloss_report',
  NftReport = 'nft_report',
  RollForwardReport = 'roll_forward_report',
  JournalEntryDetailed = 'journal_entry_detailed_report',
  QaJournalEntryDetailed = 'qa_journal_entry_detailed_report',
  PaginatedReport = 'paginated_report',
  ImpairedAssets = 'impaired_assets',
  ReportExport = 'report_export',
  TransactionExport = 'transaction_export',
  TransactionsPageTransactionCount = 'transactions_page_transaction_count',
  BulkEditStatus = 'bulk_edit_status',
  Rules = 'rules',
  CustomFields = 'custom_fields',
  Vouchers = 'vouchers',
  VoucherUsers = 'voucher_users',
  MergeLinkToken = 'merge_link_token',
  Categories = 'categories',
  CategoryMetadata = 'category_metadata',
  TransactionType = 'transaction_types',
  EarliestTransactionDate = 'earliest_transaction_date',
  Contacts = 'contacts',
  ContactAddressOptions = 'contact_address_options',
  ContactUnknownAddressTransactionCounts = 'contact_unknown_address_transaction_counts',
  ContactTransactionCounts = 'contact_transaction_counts',
  ContactRecentTransactions = 'contact_recent_transactions',
  Attachments = 'attachments',
  ValidateChainAddress = 'validate_chain_address',
  SpamToken = 'spam_tokens',
  TokenContractAddressMappings = 'token_contract_address_mappings',
  IngestionJobs = 'ingestion_jobs',
  Status = 'status_key',
  OrgSettings = 'org_settings_key',
  OrgMetadata = 'org_metadata',
  PricingSettings = 'org_pricing_settings_key',
  PricingOverrides = 'org_pricing_overrides_key',
  AnchorSwaps = 'anchor_swaps_key',
  AccountingMethods = 'accounting_methods_key',
  AccountingMethod = 'accounting_method_key',
  AccountingConfig = 'accounting_config_key',
  Team = 'team_key',
  StableCoins = 'stable_coins_key',
  LegalEntity = 'legal_entity_key',
  FilterOptions = 'filter_options_key',
  DagRuns = 'dag_runs_key',
  NextDagRun = 'next_dag_run_key',
  TransactionCategories = 'transaction_categories',
  OrgsByParent = 'orgs_by_parent_key',
  DagUrl = 'dag_url_key',
  PrincipalMarketAnalysis = 'principal_market_analysis_key',
  PrincipalMarketAnalysisCurrencies = 'principal_market_analysis_currencies_key',
  PrincipalMarketAnalysisExchanges = 'principal_market_analysis_exchanges_key',
  GlobalEdits = 'global_edits',
  HasGlobalEdits = 'has_global_edits',
  DetailedMapping = 'detailed_mapping_key',
  WalletDateRanges = 'wallet_date_ranges',
  Exchanges = 'exchanges',
  ExchangeDateRanges = 'exchange_date_ranges',
  TransactionsDashboardTransactionCount = 'transactions_dashboard_transaction_count',
  ExchangeSourceTags = 'exchange_source_tags',
  AllSourceTags = 'all_source_tags',
  FavoriteReports = 'favorite_reports',
  InternalsMigrationDate = 'internals_migration_date',
  PendingChanges = 'pending_changes',
  PriceOverrideUploads = 'price_override_uploads',
  InvalidRawCsvTransactions = 'invalid_raw_csv_transactions',
}
